export default "//static.tradera.net/touchweb/static/output/images/push-splash-icon.71e29952.svg";